import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule }  from '@angular/router';
import { ShareModule} from "../share.module";
import { DataTableModule } from "angular2-datatable";
//import { DataFilterPipe }   from "../data-filter.pipe";
//import { DataUnitFilterPipe }   from "../data-unit-filter.pipe";
//import { DataLevelFilterPipe }   from "../data-level-filter.pipe";
//import { DataTutorFilterPipe }   from "../data-tutor-filter.pipe";
//import { DataEmailFilterPipe }   from "../data-email-filter.pipe";
//import { DataGroupFilterPipe }   from "../data-group-filter.pipe";
import { SortableModule } from 'ng2-bootstrap';
import * as _ from 'underscore';

/*
 * Components
 */
import { WebadminComponent } from './webadmin.component';
import { MemberlistComponent } from './memberList.component';
import { JourneyComponent } from './journey.component';
import { ImportMemberComponent } from './importMember.component';
import { AssignComponent } from './assign.component';
import { SpritjoyComponent } from './spritjoy.component';
import { MessageComponent } from './message.component';

/*
* Routning
*/
import { WebadminRoutingModule }     from './webadmin-routing.module';

/*
* Service
*/
import { MemberService } from '../member/member.service';

@NgModule({
  declarations: [
    WebadminComponent,
    MemberlistComponent,
    JourneyComponent,
    ImportMemberComponent,
    AssignComponent,
    SpritjoyComponent,
    MessageComponent,
    //DataFilterPipe,
    //DataEmailFilterPipe,
    //DataTutorFilterPipe,
    //DataLevelFilterPipe,
    //DataUnitFilterPipe,
    //DataGroupFilterPipe
  ],
  imports: [
  	CommonModule,
    FormsModule,
    WebadminRoutingModule,
    DataTableModule,
    ShareModule,
    SortableModule.forRoot()
  ],
  providers: [MemberService]
})

export class WebadminModule {}



// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/webadmin/webadmin.module.ts